import moment from 'app/modules/datetime';
import lang from 'app/lib/moment/lang/en';

moment.lang('en', lang);




// WEBPACK FOOTER //
// ./src/web/js/app/datetime.en.js